
    document.querySelectorAll(".faq-header").forEach(header => {
      header.addEventListener("click", () => {
        const faq = header.parentElement;
        faq.classList.toggle("active");

        // Close others when opening one
        document.querySelectorAll(".faq").forEach(item => {
          if (item !== faq) {
            item.classList.remove("active");
          }
        });
      });
    });
